import React from "react";
import PropTypes from "prop-types";
import Radium from "radium";
import FunnelGraph from "ikizmet-funnel-graph-js";

class FunnelGraphComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasMounted: false,
      haveData: false
    };
  }

  checkForValues() {
    if (this.props.showGraphWithoutValues) {
      return true;
    }
    let haveValues = false;

    this.props.values.map((item) => {
      item.map((item) => {
        if (item !== 0) {
          haveValues = true;
        }
      });
    });

    return haveValues;
  }

  drawGraph() {
    let graph = new FunnelGraph({
      container: this.props.container ? "." + this.props.container : ".funnel",
      hideSubLabels: this.props.hideSubLabels,
      gradientDirection: this.props.gradientDirection,
      subLabelVisibility: this.props.subLabelVisibility,
      data: {
        labels: this.props.labels,
        subLabels: this.props.subLabels,
        colors: this.props.colors,
        values: this.props.values,
        rawDataValues: this.props.rawDataValues,
        percentLabels: this.props.percentLabels,
        subPercents: this.props.subPercents,
        averageValues: this.props.averageValues,
        averageTooltip: this.props.averageTooltip,
        breakdownRawData: this.props.breakdownRawData
      },
      displayPercent: true,
      direction: this.props.direction,
      width: this.props.width,
      height: this.props.height
    });

    this.checkForValues() && graph.draw();
  }

  componentDidMount() {
    this.drawGraph();
  }

  render() {
    return (
      <div id={this.props.id} data-testid={this.props.id}>
        <div className={this.props.container ? this.props.container : "funnel"} />
        {!this.checkForValues() && <p className="error">No data found for selected date.</p>}
      </div>
    );
  }
}

FunnelGraphComponent.propTypes = {
  id: PropTypes.string,
  colors: PropTypes.array,
  direction: PropTypes.string,
  gradientDirection: PropTypes.string,
  hideSubLabels: PropTypes.bool,
  subLabelVisibility: PropTypes.array,
  subLabels: PropTypes.array,
  labels: PropTypes.array,
  width: PropTypes.number,
  height: PropTypes.number,
  values: PropTypes.array,
  rawDataValues: PropTypes.array,
  percentLabels: PropTypes.array,
  subPercents: PropTypes.array,
  breakdownRawData: PropTypes.array,
  averageValues: PropTypes.array,
  averageTooltip: PropTypes.string,
  showGraphWithoutValues: PropTypes.bool
};

export default Radium(FunnelGraphComponent);
